import { useInputBarTarget } from "@/stores/input-bar-target-store";
import { captureDesktopChatAuthScopeGuard } from "@/desktop/desktop-chat-auth-scope";

export interface InputTargetRouteCapture {
  /** True unless the desktop auth scope has rotated since capture. */
  isCurrentScope: () => boolean;
  /**
   * True unless something else has claimed the input bar's routing since
   * capture: the auth scope went stale, or a new routing intent started
   * (e.g. New Chat or another pick). The viewed project plays no part: a
   * pick targets a chat in any project and never moves the view.
   */
  routeIsCurrent: () => boolean;
}

/**
 * Captures the desktop auth scope and the input bar's routing intent at the
 * moment a chat or sub-agent pick begins — before any `await`. Shared by
 * `useConversationSelect` (chat picks) and `usePickInputTarget` (sub-agent
 * picks) so a later awaited step can confirm nothing else raced ahead of it.
 */
export function captureInputTargetRoute(): InputTargetRouteCapture {
  const isCurrentScope = captureDesktopChatAuthScopeGuard();
  const initialIntentId = useInputBarTarget.getState().intentId;
  return {
    isCurrentScope,
    routeIsCurrent: () =>
      isCurrentScope() &&
      useInputBarTarget.getState().intentId === initialIntentId,
  };
}
